import React from "react";
import * as palette from "@govlaunch/palette";
import { validateButtonWidth } from "./fieldValidation";

export default function NumberInput({ fieldName, label, placeholder, data, setData, minValue, maxValue }) {
  return (
    <div
      css={{
        display: "grid",
        alignItems: "center",
        gridTemplateColumns: "1fr",
        gridRowGap: 4,
      }}
    >
      <span>{label}</span>

      <input
        type="number"
        name={fieldName}
        placeholder={placeholder}
        value={data[fieldName]}
        onChange={(e) => {
          setData({
            ...data,
            [fieldName]: e.target.value,
          });
        }}
        css={{
          margin: 0,
          padding: 8,
          border: "solid 1px",
          borderColor: validateButtonWidth(data[fieldName]) ? palette.sealBlue : palette.red,
          borderRadius: 2,
        }}
        min={minValue || 10}
        max={maxValue || 100}
      />
    </div>
  );
}
